import React from 'react';

import { ReactComponent as WhatsApp } from '/src/images/icons/whatsapp-colored.svg';

type WhatsappProps = {
  whatsappNumber: number;
};

export const Whatsapp = ({ whatsappNumber }: WhatsappProps) => {
  return (
    <a
      className="fixed bottom-28 right-5 z-40"
      rel="noreferrer"
      href={`https://wa.me/${whatsappNumber}/`}
      target="_blank"
      tabIndex={0}
    >
      <WhatsApp className="h-15 w-15 " imageclass="shadow-default" />
    </a>
  );
};
